import { render, staticRenderFns } from "./BrandDescribe.vue?vue&type=template&id=5833cf5e"
import script from "./BrandDescribe.vue?vue&type=script&lang=js"
export * from "./BrandDescribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports